module.exports = __webpack_public_path__ + "464d87db2550dc0a078133d311c410c6.png";